import Schedule from "../../../../src/components/schedule";
import * as React from 'react';
export default {
  Schedule,
  React
};